export enum PaymentStatus {
  PENDING = "PENDING",
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}

export enum PaymentMethod {
  MTN_MOMO = "MTN_MOMO",
  AIRTEL_MONEY = "AIRTEL_MONEY",
  CREDIT_DEBIT = "CREDIT_DEBIT",
  PAYPAL = "PAYPAL",
}

export enum PaymentProvider {
  STRIPE = "STRIPE",
  PAYSTACK = "PAYSTACK",
  FLUTTERWAVE = "FLUTTERWAVE",
  MTN_MOMO = "MTN_MOMO",
  AIRTEL_MONEY = "AIRTEL_MONEY",
}
